import type { TemplateFieldType } from '@vivport/backend/types';

export const OTHER_OPTION = '__other__';

export interface FieldControlSpec {
  type: TemplateFieldType;
  options?: string[];
  allowOther?: boolean;
}

export interface FieldControlState {
  value: string;
  other: string;
}

export const EMPTY_CONTROL_STATE: FieldControlState = { value: '', other: '' };

export function resolveControlValue(state: FieldControlState): string {
  return (state.value === OTHER_OPTION ? state.other : state.value).trim();
}
